export const SENTRY_RELEASE: string | undefined = 'd5e7892d7e0352e1ddf13abadf1bd9f734dcda63';
